import React, { useState } from 'react'
import { func } from 'prop-types'
import KitActivationModal from 'components/KitActivationModal'
import { IconBox, Column, Row, StyledButton } from './component.styles'
import { TEXT_KIT_ACTIVATION } from './constants'

const KitActivationLink = ({ navigationEvent }) => {
  const [showModalKit, setShowModalKit] = useState(false)
  const openModal = event => {
    if (event.type !== 'click' && event.key !== 'Enter') {
      return
    }
    setShowModalKit(true)
  }

  const closeModal = () => {
    if (showModalKit) setShowModalKit(false)
  }

  return (
    <Column>
      <Row>
        <StyledButton
          data-testid="text-link-kit-activation"
          onClick={event => openModal(event)}
          title={TEXT_KIT_ACTIVATION}
        >
          <span>
            <IconBox aria-hidden="true" role="presentation" />
            {TEXT_KIT_ACTIVATION}
          </span>
        </StyledButton>
      </Row>
      <KitActivationModal
        dataTestId="kit-activation-modal"
        isModalOpen={showModalKit}
        modalClose={closeModal}
        navigationEvent={navigationEvent}
      />
    </Column>
  )
}

KitActivationLink.propTypes = {
  navigationEvent: func,
}

export default KitActivationLink
